'use client';

import dynamic from 'next/dynamic';

// The echo bot pulls in motion/react, streamdown, persistent-string-storage,
// and the EchoAvatarVideo asset. Lazy-load via a client component so we can
// use `ssr: false` — the bot has a built-in initial delay anyway.
const RealEstateEchoBot = dynamic(
  () =>
    import('./realestate-echo-bot').then(mod => ({
      default: mod.RealEstateEchoBot,
    })),
  { ssr: false },
);

export { RealEstateEchoBot as LazyRealEstateEchoBot };
